// @flow @format
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import {Router, browserHistory} from 'react-router';

class App extends Component<{
	routes: {},
	store: {},
}> {
	static propTypes = {
		routes: PropTypes.object.isRequired,
		store: PropTypes.object.isRequired,
	};

	render() {
		return (
			<Provider store={this.props.store}>
				<Router history={browserHistory} routes={this.props.routes} />
			</Provider>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js